import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { HeaderBaseComponent } from 'src/app/base/components/header-base.component';
import { AuthService } from 'src/app/base/services/auth/auth.service';
import { NavService } from 'src/app/base/services/nav/nav.service';
import { WorkflowService } from 'src/app/base/services/workflow/workflow.service';
import { AppidService } from 'src/app/base/services/appid/appid.service';

@Component({
    selector: 'app-easysuite-header',
    templateUrl: './easysuite-header.component.html',
    styleUrls: ['./easysuite-header.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class EasysuiteHeaderComponent extends HeaderBaseComponent implements OnInit {

    logoLoaded: boolean = false; 

    constructor(
        public auth: AuthService, 
        public nav: NavService, 
        public app: AppComponent, 
        public workflow: WorkflowService, 
        public appidService: AppidService,
        route: ActivatedRoute
    ) {
        super(auth, nav, app, workflow, appidService, route);
    }

    ngOnInit(): void {

        // Executes the logic of the HeaderBaseComponent (showHeaderInfo, etc).
        super.ngOnInit();
    }

}
